import * as React from 'react';
import * as styles from './styles.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { Icon, IIconStyles } from '@fluentui/react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';

export default observer(function DragHandle({
    size,
    className,
}: {
    size: number;
    className?: string;
}) {
    const iconStyles: IIconStyles = {
        root: {
            fontSize: size,
        },
    };
    return (
        <div className={classNames(className!, styles.dragHandleContainer)}>
            <Icon
                className={styles.dragHandle1}
                styles={iconStyles}
                iconName={ControlIcons.MoreVertical}
            />
            <Icon
                className={styles.dragHandle2}
                styles={iconStyles}
                iconName={ControlIcons.MoreVertical}
            />
        </div>
    );
});
